var _rect, _defs, _defs2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuoteBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 300",
    width: 900,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 300,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "66.7%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "-10%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "110%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "33.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "-10%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "110%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 270C-38.4 268.4 -76.8 266.8 -102.6 247.6C-128.3 228.4 -141.4 191.7 -166.9 166.9C-192.3 142.1 -230.2 129.2 -249.4 103.3C-268.7 77.5 -269.3 38.7 -270 0L0 0Z",
    fill: "#FBAE3C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -270C39.9 -270.8 79.9 -271.7 103.3 -249.4C126.8 -227.2 133.7 -181.9 154.9 -154.9C176 -127.9 211.3 -119.2 232.8 -96.4C254.4 -73.7 262.2 -36.8 270 0L0 0Z",
    fill: "#FBAE3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBg);
export default __webpack_public_path__ + "static/media/quote-bg.215e9d7354d54bc8e7a2b625842d7fa3.svg";
export { ForwardRef as ReactComponent };